export default {
    props: {
        hint: null,
        error: null,
    },
    watch: {
        error: {
            immediate: true,
            handler(val) {
                this.innerError = val
            },
        },
    },
    computed: {
        hintText() {
            return this.hasError && this.innerError
                ? typeof this.innerError === 'string'
                    ? this.innerError
                    : this.hint
                : this.hint
        },

        hasError() {
            return this.innerError && this.innerError !== ''
        },
    },
    data() {
        return {
            innerError: null,
        }
    },
}
